import { ISaveBackCountRequest } from "src/app/settings/interfaces/save-back-count-request-interface";
import { BAATypeEnum } from "../../interfaces/BAATypeEnum";
import { IC3C5SettingValue } from "../../interfaces/IC3C5SettingValue.interface";
import { PricingOption } from "../../interfaces/PricingOption";

export class GetAllPharmacies {
  static readonly type = '[Profile] get all pharmacies';
}

export class GetUserPharmacies {
  static readonly type = '[Profile] get user pharmacies list';
}

export class SetCurrentPharmacy {
  static readonly type = '[Profile] set user pharmacy manually';

  constructor(public pharmacyId: string) {
  }
}

export class GetPharmacyByNPI {
  static readonly type = '[Profile] get pharmacy information by NPI number';

  constructor(public npiNumber: number) {
  }
}

export class GetPharmacyById {
  static readonly type = '[Profile] get pharmacy information by id';

  constructor(public id: string) {
  }
}

export class SavePharmacyNPI {
  static readonly type = '[Profile] save user pharmacy NPI';

  constructor(public npi: number) {
  }
}

export class SavePharmacySelectedBaa {
  static readonly type = '[Profile] Save Pharmacy Selected Baa';

  constructor(public baa: BAATypeEnum) {
  }
}

export class SavePharmacyForm {
  static readonly type = '[Profile] save user pharmacy data';

  constructor(public pharmacyForm: any) {
  }
}

export class SavePharmacyDetails {
  static readonly type = '[Profile] save user pharmacy on sign up';
}

export class UpdatePharmacyDetails {
  static readonly type = '[Profile] update user pharmacy in settings';

  constructor(public pharmacyDetails: any) {
  }
}
export class SetPricingOption {
  static readonly type = '[Profile] set pricing option';

  constructor(public pricingOption: PricingOption) {
  }
}
export class EnableC3toC5Drugs {
  static readonly type = '[Profile] Enable C3 to C5 Drugs';

  constructor(public pin: number, public value?: IC3C5SettingValue) {
  }
}

export class UpdateDrugsToTrack {
  static readonly type = '[Profile] Update Drugs To Track';

  constructor(public pin: number, public drugsOfInterest: string[]) {
  }
}

export class ToggleInventoryLocations {
  static readonly type = '[Profile] Toggle Inventory Locations';

  constructor(public pin: number) {
  }
}

export class ToggleBackCount {
  static readonly type = '[Profile] Toggle Back Count';

  constructor(public request: ISaveBackCountRequest) {
  }
}

export class UpdateBackCount {
  static readonly type = '[Profile] Update Back Count';

  constructor(public request: ISaveBackCountRequest) {
  }
}

export class ToggleCompounding {
  static readonly type = '[Profile] Toggle Compounding';

  constructor(public pin: number) {
  }
}
